import React from "react";
import { useI18n } from "../i18n/LanguageContext";
import { Link } from "react-router-dom";

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer data-testid="site-footer" className="border-t border-habitus-border bg-ivory">
      <div className="px-6 md:px-12 lg:px-24 max-w-[1400px] mx-auto py-20 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <div className="font-mono text-sm tracking-[0.35em] uppercase text-charcoal mb-6">HABITUS</div>
          <p className="font-headings text-2xl text-charcoal/80 leading-snug max-w-xs">
            {t.footer.tagline}
          </p>
        </div>
        <div>
          <div className="overline mb-5">{t.footer.nav}</div>
          <div className="flex flex-col gap-3">
            <a href="#concept" className="font-body text-sm text-charcoal/70 hover:text-brass transition-colors">{t.nav.concept}</a>
            <a href="#system" className="font-body text-sm text-charcoal/70 hover:text-brass transition-colors">{t.nav.layers}</a>
            <a href="#membership" className="font-body text-sm text-charcoal/70 hover:text-brass transition-colors">{t.nav.membership}</a>
            <a href="#waitlist" className="font-body text-sm text-charcoal/70 hover:text-brass transition-colors">{t.nav.waitlist}</a>
            <Link to="/admin" data-testid="footer-admin-link" className="font-body text-sm text-charcoal/40 hover:text-brass transition-colors">{t.nav.admin}</Link>
          </div>
        </div>
        <div>
          <div className="overline mb-5">Notice</div>
          <p className="font-body text-sm text-charcoal/60 leading-relaxed max-w-xs">{t.footer.legal}</p>
        </div>
      </div>
      <div className="border-t border-habitus-border">
        <div className="px-6 md:px-12 lg:px-24 max-w-[1400px] mx-auto py-6 flex flex-col md:flex-row justify-between gap-2">
          <span className="font-mono text-[0.65rem] uppercase tracking-widest text-charcoal/40">
            © {new Date().getFullYear()} HABITUS. {t.footer.rights}
          </span>
          <span className="font-mono text-[0.65rem] uppercase tracking-widest text-charcoal/40">
            Global Operating Environment
          </span>
        </div>
      </div>
    </footer>
  );
}
